import { DatePipe } from '@angular/common';
import { AfterViewInit, Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { PopupMessageComponent } from 'src/app/shared/components/popup-message/popup-message.component';
import { ActivityTabs, AutomaticRefundState, buttonTypes, ComponentTypes, PartyState } from 'src/app/shared/constants/commonenums';
import { ButtonValue } from 'src/app/shared/dynamicform/models/common-models';
import { ComponentDetails } from 'src/app/shared/dynamicform/models/popup.interface';
import { OpenBookingDTO } from 'src/app/shared/Models/OpenBookingDTO';
import { FinancialEffectType, PartyPrepaymentState, PartyType } from 'src/app/shared/Models/PartyModels';
import { OperationResultState } from 'src/app/shared/Models/ResultModels';
import { BookingActivity, ClassType, SessionBookingDTO } from 'src/app/shared/Models/SessionBookingDTO';
import { CollectType, DayOfWeek, operationType } from 'src/app/shared/Models/WidgetSettingsModels';
import { GuestService } from 'src/app/shared/services/guest.service';
import { PopupService } from 'src/app/shared/services/popup.service';
import { Utilities } from 'src/app/shared/utilities/utilities';
import * as _ from 'lodash';
import { CurrencyDecimalFormatter } from 'src/app/shared/pipes/currency-decimal.pipe';


@Component({
  selector: 'app-activity-schedule',
  templateUrl: './activity-schedule.component.html',
  styleUrls: ['./activity-schedule.component.scss']
})
export class ActivityScheduleComponent extends Utilities implements OnInit, AfterViewInit, OnDestroy {
  Subscription: Subscription = new Subscription();
  cancelButton: ButtonValue;
  modifyButton: ButtonValue;
  backToSummarybtn: ButtonValue;
  BookAnotherReservationBtn: ButtonValue;
  additionalGuestBtn: ButtonValue;
  isOpenBooking: boolean;
  OperationCurrency: string;
  BookingSize: number;
  allAvailableDates = [];
  SelectedDates = [];
  cancelDialogRef: MatDialogRef<any>;
  isSessionClass: boolean;
  dayOfWeek = DayOfWeek;
  SelectedClassSchedule: any;
  BookedSessions: any = [];
  widgetData: any;
  @Output() reservationCancelled = new EventEmitter<any>();
  SelectedSessionIds = []
  @Output() reservationAllCancelled = new EventEmitter<boolean>();
  ratePlan: any;
  PartyData: any;
  AllParties: any;
  ratePlanfromToken = false;
  SelectedCoverTypeQuantities: any = [];
  SelectedBookingTypeQuantities: any = [];
  selectedClassList = [];
  SpecialMeal: any = {};
  PartyState = PartyState;
  refundDialogRef: MatDialogRef<any>;
  showModifybtn = true;
  constructor(public ts: TranslateService, public gs: GuestService, public dialog: MatDialog, private currencyDecimalFormatter: CurrencyDecimalFormatter,
    private datePipe: DatePipe, public ps: PopupService, private route: ActivatedRoute) {
    super(dialog);
    if (this.route.snapshot.params.restaurantToken) {
      this.ratePlanfromToken = true;
    }
    this.Subscription.add(this.gs.editPartyData$.subscribe(data => {
      if (data) {
        this.PartyData = data;
        this.BookingSize = this.PartyData.Size;
        if (this.PartyData.State === PartyState.Seated || this.PartyData.State === PartyState.Cancelled || this.PartyData.State === PartyState.Left) {
          this.gs.TabChange$.next(ActivityTabs.ConfirmationSummary);
        }
        if (this.PartyData.State === PartyState.Cancelled && data.SpecialMeal) {
          setTimeout(() => {
            this.reservationAllCancelled.emit(true);
            this.gs.TabChange$.next(ActivityTabs.ConfirmationSummary);
          }, 100);
        } else {
          if (this.gs.bookingSection$.value === BookingActivity.ClassBooking) {
            this.isSessionClass = data.SpecialMeal?.ClassType === ClassType.Session;
            if (this.isSessionClass) {
              this.BookedSessions = data.BookedSessions.filter(x => x.SessionState === PartyState.Pending);
              this.setSummaryData();
            } else {
              this.allAvailableDates = [];
              this.setPaymentSummary();
              this.allAvailableDates.push({
                StartDate: this.PartyData.SpecialMeal?.StartDate,
                EndDate: this.PartyData.SpecialMeal?.EndDate
              })
              this.gs.availableDates = _.cloneDeep(this.allAvailableDates);
            }
          }
        }
      }
    }));
    this.Subscription.add(this.gs.restaurantWidgetSettings$.subscribe(data => {
      if (data) {
        this.widgetData = data;
        if(this.widgetData?.OperationCurrency){
          this.OperationCurrency = this.widgetData?.OperationCurrency 
        }
      
        this.setSummaryData()
      }
    }));
    this.Subscription.add(
      this.gs.bookingPartiesData$.subscribe(data => {
        if (data) {
          this.AllParties = data;
          this.gs.editPartyData$.next(this.AllParties[0]);
          this.BookingSize = this.AllParties[0].Size;
          this.isOpenBooking = true;
          this.SelectedCoverTypeQuantities = this.AllParties[0].CoverTypeQuantities;
          this.SelectedBookingTypeQuantities = this.AllParties[0].BookingTypeQuantities;
          this.setPartiesData(data);
          if (this.AllParties[0].SpecialMealId) {
            this.showModifybtn = false;
          }
        }
        else {
          this.ratePlanfromToken = false;
        }
      })
    );
    this.Subscription.add(this.gs.SelectedClassSchedule$.subscribe(data => {
      if (data) {
        this.SelectedClassSchedule = [];
        this.SelectedClassSchedule = data;

      }
    }))
    this.Subscription.add(this.gs.RatePlanList$.subscribe(data => {
      this.ratePlan = data;
      if (this.ratePlan) {
        this.setSummaryData();
      }
    }));
  }


  setPartiesData(partyData) {
    this.allAvailableDates = [];
    let ratePlantotal = 0
    partyData = partyData.filter(x => x.State === PartyState.Pending);
    if (!partyData || !partyData.length) {
      setTimeout(() => {
        this.reservationAllCancelled.emit(true);
      }, 100);
    } else {
      partyData?.forEach(party => {
        let partySchedule: any = {};
        partySchedule.Id = party.Id;
        partySchedule.StartTime = party.SeatingTime;
        partySchedule.EndTime = party.DepartureTime;
        partySchedule.Party = party;
        if (this.ratePlan && this.ratePlan.RatePlanCalculations) {
          const selectedSlotRatePlan = this.ratePlan.RatePlanCalculations.filter(data => data.TimeRange.Start === (party.ReservedFor || party.WishedTime))[0];
          partySchedule = Object.assign(partySchedule, selectedSlotRatePlan);
        } else {
          partySchedule = Object.assign(partySchedule, {
            RatePlanVariants: {},
            variants: [],
            TotalAmount: party.RatePlanAmount
          });
        }
        if (party.PrepaymentState !== PartyPrepaymentState.Refunded) {
          ratePlantotal = ratePlantotal + Number(party.RatePlanAmount);
        }
        this.allAvailableDates.push(partySchedule);

      });
      if ((!this.ratePlan || !this.ratePlan.RatePlanCalculations)) {
        this.ratePlan = {
          TotalRatePlan: ratePlantotal, TotalMemberShipVariant: 0
        };
      } else {
        this.ratePlan.TotalRatePlan = ratePlantotal;
      }
      if (this.ratePlan.TotalRatePlan) {
        this.gs.RatePlanList$.next(this.ratePlan);
      }
    }
    this.gs.availableDates = _.cloneDeep(this.allAvailableDates);
  }

  modifySelected(slot) {
    this.gs.operation = operationType.edit;
    this.gs.bookingSection$.next(BookingActivity.OpenBooking);
    this.gs.TabChange$.next(ActivityTabs.BookingSelection);
    this.gs.selectedOpenBookingSlots = {};
    this.gs.slots_holder = [];
    this.allAvailableDates = [];
    this.gs.RefundAmount = 0;
    this.gs.TotalRefundAmount = 0;
    this.gs.isSummaryFromCart=false;

    setTimeout(() => {
      this.gs.editPartyData$.next(slot.Party);
    }, 0);
  }

  setSummaryData() {
    if (this.BookedSessions.length > 0 && this.widgetData) {
      this.allAvailableDates = [];
      const SpecialMeals = this.widgetData.AvailableSpecialMeals.filter(data => data.Id === this.PartyData.SpecialMeal.Id)[0];
      this.BookedSessions = this.BookedSessions.sort((a, b) => (a.BookedDate > b.BookedDate) ? 1 : ((b.BookedDate > a.BookedDate) ? -1 : 0))

      var BookedDates: any[] = Utilities.uniqueBy(this.BookedSessions, "BookedDate");
      BookedDates.forEach(element => {
        element['SessionIds'] = this.getSessionIds(element);
      });
      BookedDates.forEach(date => {
        let bookedinfo: any = {};
        bookedinfo['StartDate'] = date.BookedDate;
        bookedinfo['sessions'] = [];
        date.SessionIds.forEach(session => {
          const selectedActivity = SpecialMeals.ActivitySessions.filter(sessioninfo => sessioninfo.ActivitySessionId === session)[0]
          if (selectedActivity) {
            let ActivityInfo: any = {};
            ActivityInfo['Id'] = this.BookedSessions.filter(x => x.BookedDate === date.BookedDate && x.ActivitySessionId === session)[0].Id;
            ActivityInfo['Start'] = date.BookedDate.split('T')[0] + 'T' + selectedActivity.StartTime;
            ActivityInfo['End'] = date.BookedDate.split('T')[0] + 'T' + selectedActivity.EndTime;
            if (this.ratePlan && this.ratePlan.RatePlanCalculations) {
              this.ratePlan.RatePlanCalculations.forEach(rateData => {
                if (rateData.TimeRange.Start === ActivityInfo['Start']) {
                  ActivityInfo = Object.assign(ActivityInfo, rateData);
                  bookedinfo.sessions.push(ActivityInfo);
                }
              });
            } else {
              const amount = this.BookedSessions.filter(x => x.BookedDate === date.BookedDate && x.ActivitySessionId === session)[0].RatePlanAmount
              ActivityInfo = Object.assign(ActivityInfo, {
                RatePlanVariants: {},
                variants: [],
                TotalAmount: amount
              });
              bookedinfo.sessions.push(ActivityInfo);
            }
          }
        });
        this.allAvailableDates.push(bookedinfo);
      });
      this.gs.availableDates = _.cloneDeep(this.allAvailableDates);
      if (!this.ratePlan && this.PartyData.RatePlanAmount) {
        this.ratePlan = {};
        this.ratePlan.TotalRatePlan = this.PartyData.RatePlanAmount;
        this.ratePlan.TotalMemberShipVariant = 0;
        if (this.ratePlan.TotalRatePlan) {
          this.gs.RatePlanList$.next(this.ratePlan);
        }
      }
    }
    if (this.widgetData && this.PartyData) {
      let specialmeal = [];
      let activeSession = [];
      specialmeal = _.filter(this.widgetData.AvailableSpecialMeals, (meal) => {
        if (meal.Id === this.PartyData.SpecialMealId) {
          return meal;
        }
      });
      if (specialmeal && specialmeal.length) {
        this.SpecialMeal = specialmeal[0];
        activeSession = specialmeal[0].ActivitySessions;
        let classGroup = _.filter(activeSession, (session) => {
          if (session.SessionGroupId === this.PartyData.SessionGroupId) {
            return session;
          }
        })
        console.log(classGroup);
        classGroup = _.orderBy(classGroup, ['Dayofweek'], ['asc']);
        this.selectedClassList = classGroup;
      }
    }

  }
  timeConversion(hour, date, type) {
    let time = ''
    if (hour && date) {
      if (type === 'Start') {
        time = date.StartDate.split('T')[0] + 'T' + hour;
      } else {
        time = date.EndDate.split('T')[0] + 'T' + hour;
      }
    }
    return time;
  }
  getSessionIds(data) {
    return this.BookedSessions.filter(element => element.BookedDate === data.BookedDate).map(sessions => sessions.ActivitySessionId);
  }
  setPaymentSummary() {
    if (!this.ratePlan && this.PartyData.RatePlanAmount) {
      this.ratePlan = {};
      this.ratePlan.TotalRatePlan = this.PartyData.RatePlanAmount;
      this.ratePlan.TotalMemberShipVariant = 0;
      if (this.ratePlan.TotalRatePlan) {
        this.gs.RatePlanList$.next(this.ratePlan);
      }
    }
  }
  getTimeRange(data) {
    const SessionData = [];
    this.ratePlan.RatePlanCalculations.forEach(element => {
      if (element.TimeRange.Start.split('T')[0] === data.StartDate) {
        element['SessionId'] =
          SessionData.push(element);
      }
    });
    return SessionData;
  }

  ngOnInit(): void {
    this.cancelButton = {
      type: buttonTypes.cancelBtn,
      label: this.ts.instant('cancel'),
      customclass: 'class-detail__cancel-btn',
      disbaledproperity: false
    };
    this.modifyButton = {
      type: buttonTypes.confirmBtn,
      label: this.ts.instant('modify'),
      customclass: 'class-detail__confirm-btn',
      disbaledproperity: false
    };
    this.BookAnotherReservationBtn = {
      type: buttonTypes.cancelBtn,
      label: this.ts.instant('bookAnotherReservation'),
      customclass: 'reservation-confirmation__cancel-reservation',
    };
    this.additionalGuestBtn = {
      type: buttonTypes.cancelBtn,
      label: this.ts.instant('guestDetails'),
      customclass: 'reservation-confirmation__additional-guest',
      icon: 'icon-add'
    };
    this.backToSummarybtn = {
      type: buttonTypes.cancelBtn,
      label: this.ts.instant('BackToCartSummary'),
      customclass: 'reservation-confirmation__additional-guest',
    }
  }


  ngAfterViewInit() {
    this.Subscription.add(this.ps.actionEnabled$.subscribe(x => {
      if (x == ComponentTypes.cancelReservation && this.cancelDialogRef) {
        this.cancelDialogRef.close();
        this.confirmCancelation();
      }
      else if (x == ComponentTypes.cancellationChargeInfo && this.cancelDialogRef) {
        this.cancelDialogRef.close();
        this.confirmClassorSessionCancellation();
      }
      //  else {
      //   this.cancelDialogRef.close();
      //   this.checkAllReservationCancellation();
      // }
    }));

    this.Subscription.add(this.ps.cancelEnabled$.subscribe(x => {
      if (x == ComponentTypes.cancelReservation) {
        this.gs.operation = operationType.edit;
        this.gs.reservationConfirmationText = this.ts.instant('reservationDetainedConfirmationText');
      }
    }));
    if (!this.isSessionClass && !this.isOpenBooking) {
      this.gs.isClassBokking = true;
    } else {
      this.gs.isClassBokking = false;
    }
  }

  checkAllReservationCancellation() {
    if (!this.isOpenBooking) {
      if (this.SelectedSessionIds.length === 0) {
        this.reservationAllCancelled.emit(true);
        this.isOpenBooking = false;
        this.isSessionClass = false;
      } else {
        this.allAvailableDates.forEach(element => {
          element.sessions = element.sessions.filter(session => !session['checked'])
        });

        this.allAvailableDates = this.allAvailableDates.filter(date => date.sessions.length);
        if (!this.allAvailableDates.length) {
          this.reservationAllCancelled.emit(true);
          this.isOpenBooking = false;
          this.isSessionClass = false;
        }
        this.gs.availableDates = _.cloneDeep(this.allAvailableDates);
      }
    } else {
      if (this.SelectedSessionIds.length === 0) {
        this.reservationAllCancelled.emit(true);
        this.gs.editPartyData$.next(this.AllParties[0]);
        this.isOpenBooking = false;
        this.isSessionClass = false;
      } else {
        this.allAvailableDates = this.allAvailableDates.filter(date => !date['checked']);
        if (!this.allAvailableDates.length) {
          this.reservationAllCancelled.emit(true);
          this.gs.editPartyData$.next(this.AllParties[0]);
          this.isOpenBooking = false;
          this.isSessionClass = false;
        }
        this.gs.availableDates = this.allAvailableDates;
      }
    }
  }
  setCancelSummaryData(data, editdata) {
    let partyType = this.gs.selectedSpecialMeal ? this.gs.selectedSpecialMeal.IsForStandbyReservations ? PartyType[2] : PartyType[0] : '';
    if (data.State == OperationResultState.Success) {
      this.ratePlan = null;
      this.checkAllReservationCancellation();
      this.gs.RatePlanList$.next(null);

      // this.gs.getByToken(editdata.Token, '', partyType).subscribe(res => {
      //   this.gs.editPartyData$.next(res);
      // });
      this.gs.reservationConfirmationText = this.ts.instant('reservationCancellationConfirmationText')
      this.gs.message = this.ts.instant('reservationCancellationText');

      if (data.Payload != null) {
        this.gs.RefundAmount = 0;
        if (data.Payload.PaymentState == AutomaticRefundState.Succeeeded) {
          if (data.Payload.PaymentType == FinancialEffectType.FullRefund || data.Payload.PaymentType == FinancialEffectType.PartialRefund) {
            this.gs.RefundAmount += data.Payload.PaymentAmount || 0;
          }
        }
      }
      this.showRefundAmount(this.gs.RefundAmount);
      this.gs.cancelledCartItems$.next(true);
    }
  }
  confirmCancelation() {
    const editdata = this.gs.editPartyData$.value;
    let bookedSessionId = ''
    if (this.SelectedSessionIds.length == 1) {
      bookedSessionId = this.SelectedSessionIds[0];
    } else {
      bookedSessionId = null;
    }
    if (!this.isOpenBooking) {
      if (this.gs.selectedSpecialMeal.IsForStandbyReservations) {
        this.Subscription.add(this.gs.CancelStandByBooking(this.gs.restaurantWidgetSettings$.value.RestaurantId, this.gs.editPartyData$.value.Id, this.gs.language, this.SelectedSessionIds, bookedSessionId).subscribe(data => {
          this.setCancelSummaryData(data, editdata)
        }));
      } else {
        // this.Subscription.add(this.gs.CancelBooking(this.gs.restaurantWidgetSettings$.value.RestaurantId, this.gs.editPartyData$.value.Id, this.gs.language, this.SelectedSessionIds).subscribe(data => {
        //   this.setCancelSummaryData(data ,editdata)
        // }));
        this.getCancellationCharge();
      }
    } else {
      if (!this.gs.editPartyData$.value.SpecialMealId) {
        this.Subscription.add(this.gs.CancelOpenBooking(this.gs.restaurantWidgetSettings$.value.RestaurantId, this.AllParties[0].BookingId, this.gs.language, this.SelectedSessionIds).subscribe(dat => {
          if (dat.State == OperationResultState.Success) {
            this.checkresponseData(dat, editdata);
          }
        }));
      } else {
        this.Subscription.add(this.gs.CancelPrivateLessonBooking(this.gs.restaurantWidgetSettings$.value.RestaurantId, this.AllParties[0].BookingId, this.gs.language, this.SelectedSessionIds).subscribe(dat => {
          if (dat.State == OperationResultState.Success) {
            this.checkresponseData(dat, editdata);
          }
        }));
      }
    }
  }

  checkresponseData(dat, editdata) {
    this.checkAllReservationCancellation();
    this.gs.RatePlanList$.next(null);
    this.gs.reservationConfirmationText = this.ts.instant('reservationCancellationConfirmationText')
    this.gs.setMessageState(this.ts.instant('reservationCancellationText'), 0);
    let PartiesData: any;
    if (editdata.BookingId) {
      this.gs.getByToken('', editdata.BookingId).subscribe(party => {
        if (Array.isArray(party)) {
          PartiesData = party;
        } else {
          PartiesData = [];
          PartiesData.push(party)
        }
        this.gs.bookingPartiesData$.next(PartiesData);
      });
    } else {
      this.gs.getByToken(editdata.Token, '').subscribe(data => {
        PartiesData = [];
        PartiesData.push(data)
        this.gs.bookingPartiesData$.next(PartiesData);
      });
    }

    if (dat.Payload != null) {
      this.gs.RefundAmount = 0;
      if (this.SelectedSessionIds && this.SelectedSessionIds.length > 0) {
        this.SelectedSessionIds.forEach(id => {
          if (dat.Payload[id] && dat.Payload[id].AutomaticRefundState == AutomaticRefundState.Succeeeded) {
            this.gs.RefundAmount += dat.Payload[id].RefundAmount || 0;
          }
        });
      }
      else {
        Object.keys(dat.Payload).forEach(key => {
          if (dat.Payload[key] && dat.Payload[key].AutomaticRefundState == AutomaticRefundState.Succeeeded) {
            this.gs.RefundAmount += dat.Payload[key].RefundAmount || 0;
          }
        });
      }
    }

    this.showRefundAmount(this.gs.RefundAmount);
    this.gs.cancelledCartItems$.next(true)
  }

  getCancellationCharge() {
    this.gs.getCancellationCharge(this.gs.restaurantWidgetSettings$.value.RestaurantId, this.gs.editPartyData$.value.Id, this.SelectedSessionIds).subscribe(data => {
      if (data && data.Payload && data.Payload.CancellationCharge > 0) {
        this.showCancellationAlertMessage(data.Payload)
      }
      else {
        this.confirmClassorSessionCancellation();
      }
    })
  }

  confirmClassorSessionCancellation() {
    this.Subscription.add(this.gs.CancelBooking(this.gs.restaurantWidgetSettings$.value.RestaurantId, this.gs.editPartyData$.value.Id, this.gs.language, this.SelectedSessionIds).subscribe(data => {
      this.setCancelSummaryData(data, this.gs.editPartyData$.value)
    }));
  }

  showCancellationAlertMessage(cancellationDto) {
    let selectedactivity = this.gs.restaurantWidgetSettings$.value.AvailableSpecialMeals.filter(a => a.Id == this.gs.editPartyData$.value.SpecialMealId)[0];
    const collectTypeInfo = this.gs.editPartyData$.value.PrepaymentState == PartyPrepaymentState.DepositCollected && selectedactivity && !cancellationDto.WillBeChargedImmediately ?
      selectedactivity.CollectType == CollectType.CheckIn ? this.ts.instant('cancellationCheckInMessage') : this.ts.instant('cancellationCheckOutMessage') : '';
    const cancellationcharge = this.gs.restaurantWidgetSettings$.value.OperationCurrency + this.currencyDecimalFormatter.transform(cancellationDto.CancellationCharge);
    const alertmsg = this.ts.instant('cancellationFeeInfoMessage');
    const popUpMessage = [{
      confirmationMessage: alertmsg,
      dialogTitle: this.ts.instant('cancellationChargeInfo'),
      showAlert: true,
      isScrolable: true
    }];
    const componentDetails: ComponentDetails = Utilities.setComponentDetails(PopupMessageComponent, 'small', '', popUpMessage,
      popUpMessage[0].dialogTitle);
    this.cancelDialogRef = this.openCustomPopup(componentDetails, ComponentTypes.cancellationChargeInfo, '450px', '330px', true, '', this.ts.instant('Yes'),
      this.ts.instant('No'), true)
  }

  dateClicked(checked, index) {
    this.allAvailableDates[index].checked = checked;
    this.allAvailableDates[index].sessions.forEach(element => {
      element['checked'] = checked;
    });
  }

  sessionClicked(dateIndex) {
    var itemsChecked = this.allAvailableDates[dateIndex].sessions.filter(session => session['checked']).length;
    if (!itemsChecked || itemsChecked != this.allAvailableDates[dateIndex].sessions.length) {
      this.allAvailableDates[dateIndex].checked = false;
    } else {
      this.allAvailableDates[dateIndex].checked = true;
    }
  }



  cancelClick() {

    let msg = '';
    this.SelectedSessionIds = [];
    let sessionmsg = [];
    if (!this.isOpenBooking) {
      this.allAvailableDates.forEach(element => {
        if (element.sessions) {
          const selectedsession = element.sessions.filter(session => session['checked']);
          selectedsession.forEach(element => {
            this.SelectedSessionIds.push(element.Id);
            sessionmsg.push(this.datePipe.transform(element.Start, 'MMMM d, hh:mm a') + ' - ' + this.datePipe.transform(element.End, 'hh:mm a'));
          });
        }

      });
    }
    else {
      let selectedSlots = [];
      if (this.allAvailableDates.length > 1) {
        selectedSlots = this.allAvailableDates.filter(x => x['checked']);
        selectedSlots.forEach(data => {
          sessionmsg.push(this.datePipe.transform(data.StartTime, 'MMMM d, hh:mm a'));
        })
      } else {
        this.allAvailableDates[0]['checked'] = true;
        selectedSlots = this.allAvailableDates;
        selectedSlots.forEach(data => {
          sessionmsg.push(this.datePipe.transform(data.StartTime, 'MMMM d, hh:mm a'));
        })
      }
      this.SelectedSessionIds = selectedSlots.map(y => y.Id);
    }
    if (this.SelectedSessionIds.length > 0) {
      msg = sessionmsg.join(',');
    } else {
      msg = this.ts.instant('cancelEntireReservation');
    }

    this.Subscription.add(this.ts.get('AskCancelReservationConfirmation', { date: msg, locationName: this.gs.restaurantWidgetSettings$.value.RestaurantName }).subscribe(text => {
      const popUpMessage = [{
        confirmationMessage: this.SelectedSessionIds.length ? text : msg,
        dialogTitle: this.ts.instant('cancelActivity'),
        showAlert: true,
        isScrolable: true
      }];
      const height = this.SelectedSessionIds.length > 4 ? '350px' : '300px'
      const componentDetails: ComponentDetails = Utilities.setComponentDetails(PopupMessageComponent, 'small', '', popUpMessage,
        popUpMessage[0].dialogTitle);
      this.cancelDialogRef = this.openCustomPopup(componentDetails, ComponentTypes.cancelReservation, '450px', height, true, '', this.ts.instant('Yes'),
        this.ts.instant('No'), true)
    }));
  }

  modifyClick() {
    this.SelectedDates = [];
    this.allAvailableDates = [];
    this.gs.operation = operationType.edit;
    this.gs.RefundAmount = 0;
    this.gs.TotalRefundAmount = 0;
    this.gs.bookingSection$.next(BookingActivity.ClassBooking);
    this.gs.TabChange$.next(ActivityTabs.ActivitySelection);
    this.gs.isSummaryFromCart = false;
  }


  bookAnotherReservationBtn(event) {
    this.gs.setMessageState('', 0);
    this.gs.SaveBookingObj = null;
    this.gs.SessionBookingObj = {} as SessionBookingDTO;
    this.gs.slots_holder = [];
    this.gs.selectedOpenBookingSlots = {};
    this.gs.openBookingData = {} as OpenBookingDTO;
    this.gs.SelectedClassSchedule$.next([]);
    this.gs.operation = operationType.create;
    this.gs.BookNew$.next(true);
    this.gs.bookingSection$.next(BookingActivity.ClassBooking);
    this.gs.TabChange$.next(ActivityTabs.BookingSelection);
    this.gs.RatePlanList$.next(null);
    this.allAvailableDates = [];
    this.isOpenBooking = false;
    this.isSessionClass = false;
    this.gs.ispaymentInvolvedInfo = null;
    this.gs.reservationAttemptInfo = null;
    this.gs.additionalGuestPage = false;
    this.gs.additionalGuestRequired = 0;
    this.gs.slotLockId = 0;
    this.gs.RefundAmount = 0;
    this.gs.TotalRefundAmount = 0;
    this.gs.lockResult = null;
    this.BookedSessions = [];
    const SaveContact = this.gs.editPartyData$.value.Contact;
    this.gs.editPartyData$.next(null);
    this.gs.isSummaryFromCart = false;
    this.gs.BookAnotherReservation.next(true);
  }



  additionalGuest() {
    this.gs.TabChange$.next(ActivityTabs.AdditionalGuest);
  }

  showRefundAmount(amount: number) {
    if (amount > 0) {
      this.gs.TotalRefundAmount += this.gs.RefundAmount;
      this.Subscription.add(this.ts.get('refundAmountMessage', { refundAmount: this.OperationCurrency + this.currencyDecimalFormatter.transform(amount) }).subscribe(text => {
        const popUpMessage = [{
          confirmationMessage: text,
          dialogTitle: this.ts.instant('refundStatus'),
          showAlert: true
        }];
        const componentDetails: ComponentDetails = Utilities.setComponentDetails(PopupMessageComponent, 'small', '', popUpMessage,
          popUpMessage[0].dialogTitle);
        this.refundDialogRef = this.openCustomPopup(componentDetails, ComponentTypes.informationPopup, '450px', '300px', true, '', 'Ok',
          '', false);
      }));
    }
  }

  checkPartyState() {
    //  this.gs.getByToken()
  }

  ngOnDestroy(): void {
    if (this.Subscription) { this.Subscription.unsubscribe(); }
  }

  backToCartSummary(event) {
    this.gs.TabChange$.next(ActivityTabs.CartDetails);
  }
}
